export { default } from './BenefitsList'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/BenefitsList/index.js